const itemOverviewControls = document.querySelector('.ItemOverview-controls')

if (itemOverviewControls) {
  document.addEventListener('DOMContentLoaded', () => {
    const radios = document.querySelectorAll('input[name="category"]')
    const items = document.querySelectorAll('.ItemOverview-item')
    const list = document.querySelector('.ItemOverview-list')

    function filterItems(selectedCategory) {
      items.forEach((item, index) => {
        const categories = item.dataset.categories || ''
        const isLastItem = index === items.length - 1

        // Element wird angezeigt, wenn:
        // - "alle" gewählt ist
        // - oder die Kategorie im Attribut enthalten ist
        // - oder es das letzte Element ist
        const match =
          selectedCategory === 'all' ||
          categories.includes(selectedCategory) ||
          isLastItem

        item.hidden = !match
      })
    }

    radios.forEach((radio) => {
      radio.addEventListener('change', () => {
        filterItems(radio.value)

        const stickyTop =
          parseInt(getComputedStyle(itemOverviewControls).top) || 0

        const listTop = list.getBoundingClientRect().top + window.scrollY

        const targetScroll =
          listTop - itemOverviewControls.offsetHeight - stickyTop

        const badgeElement = document.querySelector('.ItemOverview-itemBadge')
        let badgeOffset = 0

        if (badgeElement) {
          badgeOffset = badgeElement.offsetHeight * 0.65
        }

        if (window.scrollY > targetScroll + 5) {
          window.scrollTo({
            top: targetScroll - badgeOffset,
            behavior: 'smooth',
          })
        }
      })
    })

    // Optional: Initialfilter setzen (falls nötig)
    const checked = document.querySelector('input[name="category"]:checked')
    if (checked) {
      filterItems(checked.value)
    }
  })
}
